






























import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import ListingActivityTagSelector from '@ui/Campaign/ListingActivityTagSelector'

settings =
  name: "ActivityTagStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]
    components: { ListingActivityTagSelector }

    data: ->
      setActivities: false

    mounted: ->
      @initializeSetActivities()

    computed:
      actionsForListingActivityTagSelector: ->
        {
          select: @selectActivityTag,
          unselect: @unselectActivityTag,
          selectAll: @selectAllActivityTags,
          unselectAll: @unselectAllActivityTags,
        }

    methods:
      initializeSetActivities: ->
        { activity_tags } = @wizard.campaignData.target.listing
        @setActivities = true if activity_tags?.length

      selectActivityTag: (option) ->
        @wizard.campaignData.target.listing.activity_tags.push option.key
      unselectActivityTag: (option) ->
        @wizard.campaignData.target.listing.activity_tags = @wizard.campaignData.target.listing.activity_tags.filter((activityTag) -> activityTag isnt option.key)
      selectAllActivityTags: (options) ->
        @wizard.campaignData.target.listing.activity_tags = options.map((option) -> option.key)
      unselectAllActivityTags: ->
        @wizard.campaignData.target.listing.activity_tags = []

      hiToggleSetActivities: (value) ->
        @setActivities = value
        @unselectAllActivityTags() if not value

export default VueOptions.vue settings
